module.exports = __webpack_public_path__ + "static/media/hero05.d465374c.jpg";